import Section from "../../components/base/Section.jsx";
import PhoneInput from "../../components/base/PhoneInput.jsx";
import Input from "../../components/base/Input.jsx";

export default function Step2({ formData, setFormData, isReadOnly = false}) {
  
    return (
    <>
      <Section title="ADRESSE">
        <Input
          label="N° et nom de rue"
          name="street_number"
          value={formData.street_number}
          setFormData={setFormData}
          type="text"
          required
          disabled={isReadOnly}
        />
        <Input
          label="Code postal"
          name="postal_code"
          value={formData.postal_code}
          setFormData={setFormData}
          type="text"
          required
          disabled={isReadOnly}
        />
        <Input
          label="Ville"
          name="city"
          value={formData.city}
          setFormData={setFormData}
          type="text"
          required
          disabled={isReadOnly}
        />
      </Section>

      {/* Contact d'urgence */}
      <Section title="EN CAS D'URGENCE">
        <Input
          label="Nom Prénom du contact d'urgence"
          name="emergency_contact"
          value={formData.emergency_contact}
          setFormData={setFormData}
          type="text"
          required
          disabled={isReadOnly}
        />
        <PhoneInput 
            name="emergency_phone"
            label="Téléphone"
            phoneValue={formData.emergency_phone}
            setFormData={setFormData}
            phoneName="emergency_phone"
            required
            disabled={isReadOnly}
        />
      </Section>
    </>
  );
}
